/**
 * Stable ECharts component ids. Every option rebuild is merged into the live chart by id, so a
 * changed id would remount a component (and lose its state) instead of updating it in place.
 */
export const LANE_HIGHLIGHT_SERIES_ID = 'lane-highlight';

/** The dots of every line's lone points, one series for all lines; see buildLonePointsOption. */
export const LONE_POINTS_SERIES_ID = 'lone-points';
export const ROW_HIGHLIGHT_SERIES_ID_PREFIX = 'row-highlight';
export const RANGE_TRACK_SERIES_ID_PREFIX = 'range-track';

/**
 * Hidden one-point series the nearest-series tooltip is shown on. Sampling and viewport filtering
 * change which real points ECharts keeps, so a raw point index is not a reliable tooltip target;
 * the anchor lives on its own axes outside the data zoom and is always resolvable.
 */
export const TOOLTIP_ANCHOR_SERIES_ID = 'tooltip-anchor';

/**
 * Hidden line series whose data backs the navigation slider's shadow preview. ECharts picks the
 * shadow's source series once at creation and never re-picks it, so the preview must be one fixed
 * series whose data we swap — see buildSliderPreviewOption.
 */
export const SLIDER_PREVIEW_SERIES_ID = 'slider-preview';

export const INSIDE_DATA_ZOOM_ID = 'plot-zoom-inside';
export const SLIDER_DATA_ZOOM_ID = 'plot-zoom-slider';

/** The plot and range-track titles, graphic text elements; see buildSectionLabelOption. */
export const PLOT_SECTION_LABEL_ID = 'section-label-plot';
export const RANGE_TRACK_SECTION_LABEL_ID = 'section-label-range-track';

export function getRowHighlightSeriesId(laneId: string) {
  return `${ROW_HIGHLIGHT_SERIES_ID_PREFIX}-${laneId}`;
}

export function getRangeTrackSeriesId(laneId: string) {
  return `${RANGE_TRACK_SERIES_ID_PREFIX}-${laneId}`;
}
